import MenuBar from "../Component/MenuBar";
import Sidebar from '../Component/Sidebar';
import Footer from "../Component/Footer";
import { NavLink } from "react-router-dom";

const Anniversary11th = () => {
    return (
        <>
            <MenuBar />
            <Sidebar />

            {/* Page Banner */}
            <section className="page-banner">
                <div className="image-layer" style={{ backgroundImage: 'url(https://sevastorage.blob.core.windows.net/seva-blob/Yugalkunj_website/background/bg-page-title-2.jpg)' }}></div>
                <div className="auto-container">
                    <h1>11<sup>th</sup> Anniversary Celebration</h1>
                </div>
                <div className="breadcrumb-box">
                    <div className="auto-container">
                        <ul className="bread-crumb clearfix">
                            <li><NavLink to="/USA/Home">Home</NavLink></li>
                            <li className="active">11th Anniversary Celebration</li>
                        </ul>
                    </div>
                </div>
            </section>

            <div className="container" style={{ paddingBottom: "40px" }}>

                {/* Heading */}
                <div className="auto-container">
                    <div className="centered">
                        <hr />
                        <h3>11<sup>th</sup> Anniversary Celebration – Musical Night</h3>
                        <h4 className="text-center" style={{ color: "#666", marginTop: "8px" }}>
                            Saturday, September 5th &nbsp;|&nbsp; 7:00 PM – 9:00 PM
                        </h4>
                        <h5 className="text-center" style={{ color: "#888", marginTop: "5px" }}>
                            Yugal Kunj &nbsp;·&nbsp; 2769 Duluth Hwy, Duluth, GA 30096
                        </h5>
                        <p className="text-center" style={{ marginTop: "12px", fontStyle: "italic", color: "#9b59b6", fontSize: "16px" }}>
                            "Come together in devotion, music and celebration of love."
                        </p>
                        <hr />
                    </div>
                </div>

                {/* Flyer Image */}
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Event Flyer</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="widget-49">
                                    <figure className="image">
                                        <img
                                            src="https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/97153409_11-Anniversary.png"
                                            alt="11th Anniversary Celebration - Musical Night"
                                            style={{ width: "100%" }}
                                        />
                                        <a
                                            href="https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/97153409_11-Anniversary.png"
                                            className="lightbox-image overlay"
                                            data-fancybox="gallery-anniversary"
                                        ></a>
                                    </figure>
                                    <br />
                                    <div className="widget-49-meeting-action">
                                        <a
                                            href="https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/97153409_11-Anniversary.png"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-sm btn-flash-border-primary"
                                        >
                                            View Flyer
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Event Details */}
                <hr />
                <div className="row">
                    <div className="col-lg-6">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">📅 Event Details</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title orange-border">
                                    <table style={{ width: "100%", fontSize: "15px", borderCollapse: "collapse" }}>
                                        <tbody>
                                            <tr style={{ borderBottom: "1px solid #eee" }}>
                                                <td style={{ padding: "10px 12px", fontWeight: "bold", color: "#7d3c98", width: "120px" }}>Event</td>
                                                <td style={{ padding: "10px 12px" }}>11<sup>th</sup> Anniversary Celebration – Musical Night</td>
                                            </tr>
                                            <tr style={{ borderBottom: "1px solid #eee", background: "#fafafa" }}>
                                                <td style={{ padding: "10px 12px", fontWeight: "bold", color: "#7d3c98" }}>Theme</td>
                                                <td style={{ padding: "10px 12px" }}>Bhajan Jamming &amp; Bollywood Classic Melodies</td>
                                            </tr>
                                            <tr style={{ borderBottom: "1px solid #eee" }}>
                                                <td style={{ padding: "10px 12px", fontWeight: "bold", color: "#7d3c98" }}>Date</td>
                                                <td style={{ padding: "10px 12px" }}>Saturday, September 5, 2026</td>
                                            </tr>
                                            <tr style={{ borderBottom: "1px solid #eee", background: "#fafafa" }}>
                                                <td style={{ padding: "10px 12px", fontWeight: "bold", color: "#7d3c98" }}>Time</td>
                                                <td style={{ padding: "10px 12px" }}>7:00 PM – 9:00 PM</td>
                                            </tr>
                                            <tr style={{ borderBottom: "1px solid #eee" }}>
                                                <td style={{ padding: "10px 12px", fontWeight: "bold", color: "#7d3c98" }}>Venue</td>
                                                <td style={{ padding: "10px 12px" }}>Yugal Kunj</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "10px 12px", fontWeight: "bold", color: "#7d3c98" }}>Address</td>
                                                <td style={{ padding: "10px 12px" }}>2769 Duluth Hwy, Duluth, GA 30096</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Program */}
                    <div className="col-lg-6">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">🎵 Program Highlights</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title orange-border">
                                    <ul className="satsang_list" style={{ fontSize: "15px", lineHeight: "2" }}>
                                        <li>🎤 &nbsp;<strong>Live Singing Performance</strong></li>
                                        <li>🎶 &nbsp;<strong>Bhajan Jamming</strong></li>
                                        <li>🎬 &nbsp;<strong>Bollywood Classic Melodies</strong></li>
                                        <li>🍽️ &nbsp;<strong>Food will be available</strong></li>
                                        <li>🚗 &nbsp;<strong>On-site Free Parking</strong></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tagline Banner */}
                <div className="row" style={{ marginTop: "10px" }}>
                    <div className="col-lg-12">
                        <div
                            style={{
                                background: "linear-gradient(135deg, #6c3483, #9b59b6)",
                                borderRadius: "10px",
                                padding: "24px 30px",
                                textAlign: "center",
                                color: "#fff",
                                boxShadow: "0 4px 15px rgba(108,52,131,0.3)"
                            }}
                        >
                            <p style={{ fontSize: "20px", fontStyle: "italic", margin: 0, fontWeight: "500", letterSpacing: "0.5px" }}>
                                ✨ "Come together in devotion, music and celebration of love." ✨
                            </p>
                        </div>
                    </div>
                </div>

                {/* Location */}
                <hr />
                <div className="row" style={{ marginBottom: "30px" }}>
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">📍 Location</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title purple-border" style={{ paddingLeft: "20px" }}>
                                    <h4>Yugal Kunj – Radha Krishna Temple &amp; Community Center</h4>
                                    <p>2769 Duluth Hwy, Duluth, GA 30096</p>
                                    <p><strong>Date:</strong> Saturday, September 5, 2026</p>
                                    <p><strong>Time:</strong> 7:00 PM – 9:00 PM</p>
                                    <p><strong>Parking:</strong> On-site free parking available</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <Footer />
        </>
    );
};

export default Anniversary11th;
